import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
  * @module contextmenu
  * @description A module to help with opening/closing **global** context menu:
  * * When user clicks on a menu item, callback function will be fired
  * * when user clicks elsewhere on screen, menu will be closed
  *
  * Note. There can only be one context menu displayed on screen at one point in time
  */
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import cx from 'classnames';
import subscribe from 'ui/utils/outside-event';

var log = require('loglevel').getLogger('core/components/contextmenu');

var globalContextMenu = null;

var ContextMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(ContextMenu, _React$Component);

  var _super = _createSuper(ContextMenu);

  function ContextMenu() {
    var _this;

    _classCallCheck(this, ContextMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClickInside", function (target) {
      var targetId = target.id;
      var menu = _this.state.menu;

      var targetMenuItem = _.find(menu, {
        id: targetId
      });

      if (targetMenuItem && targetMenuItem.action) {
        targetMenuItem.action();

        _this.setState({
          menu: []
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickOutside", function () {
      _this.setState({
        menu: []
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getDimension", function () {
      if (_this.node) {
        _this.setState({
          dimension: {
            width: _this.node.offsetWidth,
            height: _this.node.offsetHeight
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "addHandler", function () {
      _this.handler = subscribe(_this.node).onInside(_this.onClickInside).onOutside(_this.onClickOutside);
    });

    _defineProperty(_assertThisInitialized(_this), "isOpen", function () {
      return !_.isEmpty(_this.state.menu);
    });

    _defineProperty(_assertThisInitialized(_this), "open", function (position, menu, id) {
      _this.setState({
        menu: menu,
        position: position,
        id: id
      });
    });

    _defineProperty(_assertThisInitialized(_this), "state", {});

    return _this;
  }

  _createClass(ContextMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addHandler();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this.handler.unsubscribe();

      if (this.isOpen()) {
        this.addHandler();
      }

      if (!_.isEqual(this.state.menu, prevState.menu) && _.isEqual(this.state.dimension, prevState.dimension)) this.getDimension();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handler.unsubscribe();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          menu = _this$state.menu,
          position = _this$state.position,
          dimension = _this$state.dimension,
          id = _this$state.id;

      if (!this.isOpen()) {
        return null;
      } else {
        var x = position.x,
            y = position.y;

        if (dimension) {
          var width = dimension.width,
              height = dimension.height;
          if (x + width > window.document.documentElement.clientWidth) x = window.document.documentElement.clientWidth - width;
          if (y + height > window.document.documentElement.clientHeight) y = window.document.documentElement.clientHeight - height;
        }

        var style = {
          left: x + 'px',
          top: y + 'px',
          zIndex: 9999
        };
        return /*#__PURE__*/React.createElement("ul", {
          ref: function ref(_ref2) {
            _this2.node = _ref2;
          },
          id: id,
          className: "c-contextmenu c-menu sub",
          style: style
        }, _.map(menu, function (_ref, idx) {
          var itemId = _ref.id,
              text = _ref.text,
              className = _ref.className,
              isHeader = _ref.isHeader,
              disabled = _ref.disabled;
          return /*#__PURE__*/React.createElement("li", {
            className: cx(className, {
              header: isHeader,
              disabled: disabled
            }),
            id: itemId,
            key: idx
          }, text || id);
        }));
      }
    }
  }]);

  return ContextMenu;
}(React.Component);

_defineProperty(ContextMenu, "propTypes", {});

export default {
  /**
   * Open context menu
   * @param {event|object} evt - event or simuated event with location information
   * @param {number} evt.pageX - x position to open menu at
   * @param {number} evt.pageY - y position to open menu at
   * @param {Array.<object>} menu - Menu to show on screen<br>Each item has the follow properties:
   * @param {string} menu.id - menu item id/key
   * @param {renderable} [menu.text=id] - menu item text
   * @param {function} [menu.action] - function to call when item is clicked
   * @param {string} [menu.className] - className for this item
   * @param {boolean} [menu.isHeader=false] - whether this item denotes a header for a group of items
   * @param {boolean} [menu.disabled=false] - whether this item is disabled
   * @param {string} [id] - id for the contextmenu
   *
   * @example
   *
  import ContextMenu from 'core/components/contextmenu'
  React.createClass({
  getInitialState() {
      return {}
  },
  fetchMovieDetails(source) {
      // load data from source
      this.setState({source})
  },
  handleContextMenu(evt) {
      let menuItems = _.map(['imdb','rotten'], source=>{
          return {id:source, text:`Fetch ${source} Data`, action:this.fetchMovieDetails.bind(this,source)}
      })
      ContextMenu.open(evt, menuItems);
  },
  render() {
      return <span className='c-link' onContextMenu={this.handleContextMenu}>
          Right click on me
      </span>
  }
  })
     */
  open: function open(evt, menu, id) {
    evt.preventDefault && evt.preventDefault();

    if (!globalContextMenu) {
      var node = document.createElement('DIV');
      node.id = 'g-cm-container';
      document.getElementById('app-container').appendChild(node);
      globalContextMenu = ReactDOM.render( /*#__PURE__*/React.createElement(ContextMenu, null), document.getElementById('g-cm-container'));
    }

    globalContextMenu.open({
      x: evt.pageX - window.pageXOffset,
      y: evt.pageY - window.pageYOffset
    }, menu, id);
  },

  /**
   * Check if context menu is open
   * @return {boolean} Is open?
   *
   * @example
  console.log(ContextMenu.isOpen())
   */
  isOpen: function isOpen() {
    return globalContextMenu && globalContextMenu.isOpen();
  },

  /**
   * Close context menu if opened
   *
   * @example
  ContextMenu.close();
   */
  close: function close() {
    globalContextMenu && globalContextMenu.onClickOutside();
  }
};